// @flow
import React from 'react';
import classNames from '@ta/common.classnames';
import styles from './SegmentImages.css';

type Props = {|
  active: boolean,
|};

/**
 * Background images shown on the "who are you traveling with?" screen
 */
const SegmentImages = ({ active }: Props) => (
  <div className={classNames(styles.segmentImages, { [styles.active]: active })}>
    <div className={`${styles.column} ${styles.column1}`}>
      <div className={`${styles.image} ${styles.image1}`} />
      <div className={`${styles.image} ${styles.image2}`} />
    </div>
    <div className={`${styles.column} ${styles.column2}`}>
      <div className={`${styles.image} ${styles.image3}`} />
      <div className={`${styles.image} ${styles.image4}`} />
      <div className={`${styles.image} ${styles.image5}`} />
    </div>
    <div className={`${styles.column} ${styles.column3}`}>
      <div className={`${styles.image} ${styles.image6}`} />
      <div className={`${styles.image} ${styles.image7}`} />
    </div>
  </div>
);

export default SegmentImages;
